import { useState, useEffect, useRef } from "react";
import { arrowDown } from "helper/icons";
import { CheckBox } from "../checkbox";
import SearchBar from "../search";
import { globalVariables } from "helper/globalVariables";
import { cross } from "helper/images";

const MultiSelectWithSearch = (props) => {
  const {
    width = "w-[318px] lg:w-[349px]",
    isMultiSelect = false,
    options = [],
    label,
    errorMsg,
    placeholder,
    onChange,
    showCross,
    onClear,
    defaultSelectedOptions,
    closeOnSelect = false,
  } = props || {};
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  useEffect(() => {
    if (defaultSelectedOptions) {
      setSelectedOptions([defaultSelectedOptions]);
    }
  }, [defaultSelectedOptions]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const optionsData = [...options];
    const data = optionsData.filter((option) =>
      option.label.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredOptions(data);
  }, [searchTerm]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const selectOption = (option, index) => {
    // debugger;
    let updatedSelectedOptions = [];
    let shouldCloseDropdown = false;

    if (!isMultiSelect) {
      updatedSelectedOptions = [option];
      shouldCloseDropdown = true;
    } else {
      if (!selectedOptions.some((item) => item.id === option.id)) {
        updatedSelectedOptions = [...selectedOptions, option];
      } else {
        updatedSelectedOptions = selectedOptions.filter(
          (item) => item.id !== option.id
        );
      }
    }

    setSelectedOptions([]);
    setIsOpen(shouldCloseDropdown);
    onChange?.(updatedSelectedOptions, index);
  };

  const handleOptionClick = (option) => {
    if (!isMultiSelect) {
      setSelectedOptions([option]);
      setIsOpen(false);
      setSearchTerm("");
      onChange?.([option]);
    } else {
      const selectedOptionsArr = [...selectedOptions];
      const elementIndex = selectedOptionsArr.findIndex(
        (e) => e.id === option.id
      );
      if (elementIndex !== -1) {
        selectedOptionsArr.splice(elementIndex, 1);
      } else {
        selectedOptionsArr.push(option);
      }

      setSelectedOptions(selectedOptionsArr);
      onChange?.(selectedOptionsArr);

      // Close dropdown after selection if closeOnSelect is true
      if (closeOnSelect) {
        setIsOpen(false);
        setSearchTerm("");
      }
    }
  };
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };
  return (
    <div className="relative" ref={dropdownRef}>
      {!!label && (
        <div className="mb-0.5">
          <span className="text-gray-700 font-medium text-sm">{label}</span>
        </div>
      )}
      <button
        type="button"
        className={`inline-flex focus:outline-none items-center justify-between px-2.5 py-2.5 text-gray-700 bg-white border rounded-md shadow-100 ${width}`}
        onClick={toggleDropdown}
      >
        {selectedOptions.length === 1 ? (
          <span>{selectedOptions[0].label}</span>
        ) : (
          <span className="text-gray-900/50 text-base font-normal">
            {selectedOptions.length > 0
              ? `${selectedOptions.length} elements selected`
              : placeholder}
          </span>
        )}
        {selectedOptions.length === 0 && (
          <img
            src={arrowDown}
            height={20}
            width={20}
            alt=""
            className={`transform rotate-180`}
          />
        )}

        {selectedOptions.length > 0 && (
          <img
            onClick={(e) => {
              e?.stopPropagation();
              setSelectedOptions([]);
              onClear?.();
            }}
            src={cross}
            height={24}
            width={24}
            alt=""
          />
        )}
      </button>
      {isOpen && (
        <div className="absolute mt-2 z-10 w-full bg-white rounded-md shadow-md">
          <div className="flex items-center border-b border-gray-300">
            <SearchBar
              onChange={handleSearch}
              width={width}
              placeholder={globalVariables.search}
              hasBorder={false}
            />
          </div>

          <ul className="max-h-[200px] overflow-auto">
            {filteredOptions.map((option, index) => (
              <li
                key={option.id}
                className={`flex items-center p-4 cursor-pointer hover:bg-gray-100 ${
                  index !== filteredOptions?.length - 1 ? "border-b" : ""
                } border-gray-200 text-sm text-gray-700 hover:bg-primary/50 hover:text-white`}
                onClick={() => handleOptionClick(option)}
              >
                {isMultiSelect &&
                  (selectedOptions.some((item) => item.id === option.id) ? (
                    <CheckBox isChecked />
                  ) : (
                    <CheckBox />
                  ))}
                <span>{option.label}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      {!!errorMsg && (
        <span className="text-red font-medium text-sm mt-1 pt-2">
          {errorMsg}
        </span>
      )}
    </div>
  );
};

export default MultiSelectWithSearch;
